<template>
  <div>
    <div class="container-fluid">
      <b-row>
        <b-col>
          <canvas id="operation-chart"></canvas>
          <!-- <b-table-simple hover small caption-top responsive>
    <caption class="captionTable">Latest Operation Logs</caption>
    <b-thead>
      <b-tr>
        <b-th>Status</b-th>
        <b-th>Date</b-th>
        <b-th>Source</b-th>
        <b-th>Description</b-th>
        <b-th>Result</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr v-for="item in operationLogs" :key="item.c_id">
        <b-th stacked-heading="Status" class="text-center" variant="success">{{item.c_u_Status ==1 ? "Success" : ""}}</b-th>
        <b-th stacked-heading="Date" class="text-center">{{item.c_u_Date}}</b-th>
        <b-td stacked-heading="Source" class="text-center">{{item.sources.c_u_ReferenceSource}}</b-td>
        <b-td stacked-heading="Description" class="text-center">{{item.c_u_Description}}</b-td>
        <b-td stacked-heading="Result" class="text-center">{{item.c_u_Result}}</b-td>
      </b-tr>
    </b-tbody>
    <b-tfoot>
      <b-tr>
        <b-td colspan="7" variant="secondary" class="text-right">
          Total of Logs in last 7 Days: <b>{{operationLogs.length}}</b>
        </b-td>
      </b-tr>
    </b-tfoot>
  </b-table-simple>
          <!-- Table for the ERRORS in Operation
          <b-table-simple hover small caption-top responsive>
    <caption class="captionTable">Latest Operation Errors</caption>
    <b-thead>
      <b-tr>
        <b-th>Status</b-th>
        <b-th>Date</b-th>
        <b-th>Source</b-th>
        <b-th>Description</b-th>
        <b-th>Result</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr v-for="item in operationErrors" :key="item.c_id">
        <b-th stacked-heading="Status" class="text-center" variant="danger">{{item.c_u_Status == -1 ? "Error" : ""}}</b-th>
        <b-th stacked-heading="Date" class="text-center">{{item.c_u_Date}}</b-th>
        <b-td stacked-heading="Source" class="text-center">{{item.sources.c_u_ReferenceSource}}</b-td>
        <b-td stacked-heading="Description" class="text-center">{{item.c_u_Description}}</b-td>
        <b-td stacked-heading="Result" class="text-center">{{item.c_u_Result}}</b-td>
      </b-tr>
    </b-tbody>
    <b-tfoot>
      <b-tr>
        <b-td colspan="7" variant="secondary" class="text-right">
          Total of Errors in last 7 Days: <b>{{operationErrors.length}}</b>
        </b-td>
      </b-tr>
    </b-tfoot>
          </b-table-simple>
          -->
        </b-col>
        <!-- Table of News in the Last 7 days -->
        <b-col>
          <canvas id="planet-chart"></canvas>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from "../router/index";
import Chart from "chart.js";
import ChartAnnotation from "chartjs-plugin-annotation";
import everyHourChartData from "./chart-data.js";
import operationLogsChart from "./chart-operation-logs.js";

export default {
  name: "Home",

  data() {
    return {
      items: [],
      endpointForLogs: "DashBoard/OperationLogs",
      endpointForErrors: "DashBoard/OperationErrors",
      endpointForNews: "DashBoard/News",
      operationLogs: [],
      everyHourChartData: everyHourChartData,
      operationLogsChart: operationLogsChart,
      totalItemsNews: 0,
      currentPageNews: 1,
      timer: "",
      operationErrors: [],
      newsExtractPerHour: null,
      fieldsNews: [
        {
          key: "hours",
          label: "Hours",
          formatter: (value, key, item) => {
            return item.hour;
          },
        },
        {
          key: "extracted",
          label: "Extracted News",
        },
      ],
    };
  },

  components: {},

  methods: {
    async autoReloadData() {
      this.$api.data.endpoint = this.endpointForNews;
      this.newsExtractPerHour = await this.$api.data.find();
      this.totalItemsNews = this.newsExtractPerHour.length;
      for (let index = 0; index < this.newsExtractPerHour.length; index++) {
        if (index + 1 < 12) {
          this.newsExtractPerHour[index] = {
            hour: index + 1 + ":00 AM",
            extracted: this.newsExtractPerHour[index],
          };
          this.everyHourChartData.data.labels[index] = this.newsExtractPerHour[
            index
          ].hour;
          this.everyHourChartData.data.datasets[0].data[
            index
          ] = this.newsExtractPerHour[index].extracted;
        }
        if (index + 1 >= 12) {
          this.newsExtractPerHour[index] = {
            hour: index + 1 + ":00 PM",
            extracted: this.newsExtractPerHour[index],
          };
          this.everyHourChartData.data.labels[index] = this.newsExtractPerHour[
            index
          ].hour;
          this.everyHourChartData.data.datasets[0].data[
            index
          ] = this.newsExtractPerHour[index].extracted;
        }
        if (index + 1 == 24) {
          this.newsExtractPerHour[index] = {
            hour: index + 1 + ":00 AM",
            extracted: this.newsExtractPerHour[index],
          };
          this.everyHourChartData.data.labels[index] = this.newsExtractPerHour[
            index
          ].hour;
          this.everyHourChartData.data.datasets[0].data[
            index
          ] = this.newsExtractPerHour[index].extracted;
        }
      }
    },
    async showData() {
      this.$api.data.endpoint = this.endpointForLogs;
      this.operationLogs = await this.$api.data.find();

      this.$api.data.endpoint = this.endpointForErrors;
      this.operationErrors = await this.$api.data.find();

      this.$api.data.endpoint = this.endpointForNews;
      this.newsExtractPerHour = await this.$api.data.find();
      this.totalItemsNews = this.newsExtractPerHour.length;

      //console.log(this.newsExtractPerHour);

      for (let index = 0; index < this.newsExtractPerHour.length; index++) {
        if (index < 12) {
          this.newsExtractPerHour[index] = {
            hour: index + ":00 AM",
            extracted: this.newsExtractPerHour[index],
          };
          this.everyHourChartData.data.labels[index] = this.newsExtractPerHour[
            index
          ].hour;
          this.everyHourChartData.data.datasets[0].data[
            index
          ] = this.newsExtractPerHour[index].extracted;
        }
        if (index >= 12) {
          this.newsExtractPerHour[index] = {
            hour: index + ":00 PM",
            extracted: this.newsExtractPerHour[index],
          };
          this.everyHourChartData.data.labels[index] = this.newsExtractPerHour[
            index
          ].hour;
          this.everyHourChartData.data.datasets[0].data[
            index
          ] = this.newsExtractPerHour[index].extracted;
        }
        // if (index + 1 == 24) {
        //   this.newsExtractPerHour[index] = {
        //     hour: index + 1 + ":00 AM",
        //     extracted: this.newsExtractPerHour[index]
        //   };
        //   this.everyHourChartData.data.labels[index] = this.newsExtractPerHour[
        //     index
        //   ].hour;
        //   this.everyHourChartData.data.datasets[0].data[
        //     index
        //   ] = this.newsExtractPerHour[index].extracted;
        // }
      }
      // for to create the last seven days;
      let getDaysSuccessLog = [];
      let getDaysErrorLog = [];
      var date = new Date();
      date.setDate(date.getDate() - 7);

      getDaysSuccessLog = this.operationLogs;
      getDaysErrorLog = this.operationErrors;

      _.remove(getDaysSuccessLog, function (n) {
        return n.day == date.getDate();
      });
      _.remove(getDaysErrorLog, function (n) {
        return n.day == date.getDate();
      });

      for (let x = 0; x < getDaysSuccessLog.length; x++) {
        this.operationLogsChart.data.labels[x] = getDaysSuccessLog[x].day
          ? getDaysSuccessLog[x].day
          : getDaysSuccessLog[x];
        this.operationLogsChart.data.datasets[0].data[x] = getDaysSuccessLog[x]
          .number
          ? getDaysSuccessLog[x].number
          : 0;
      }

      for (let x = 0; x < getDaysErrorLog.length; x++) {
        this.operationLogsChart.data.labels[x] = getDaysErrorLog[x].day
          ? getDaysErrorLog[x].day
          : getDaysErrorLog[x];
        this.operationLogsChart.data.datasets[1].data[x] = getDaysErrorLog[x]
          .number
          ? getDaysErrorLog[x].number
          : 0;
      }
      this.operationLogsChart.data.labels = _.uniq(
        this.operationLogsChart.data.labels
      );
      this.createChart("planet-chart", this.everyHourChartData);
      this.createChart("operation-chart", this.operationLogsChart);
    },
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    },
    createChart2(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    },
  },
  computed: {
    ...mapGetters({}),
  },

  async mounted() {
    this.showData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.captionTable {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: white;
  text-align: center;
  caption-side: bottom;
  background-color: #007bff;
  margin-top: 5px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue